export const WAG_DISCLOSURE_TEXT =
  'Licensed support is provided by Wealth Assurance Group (WAG), a separate licensed entity. ' +
  'By selecting a licensed option you agree to be contacted by WAG about your planning goals. ' +
  'This is not insurance or financial advice from Waterlily.';

interface WagDisclosureProps {
  className?: string;
}

export function WagDisclosure({ className }: WagDisclosureProps) {
  return <p className={className}>{WAG_DISCLOSURE_TEXT}</p>;
}
